// import { useNavigate } from 'react-router-dom';
// import ReactMarkdown from 'react-markdown';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import { URL_ENDPOINTS } from '../../config/constants';

// const PublicationCard = ({ publication }) => {
//     const navigate = useNavigate();
//     const imageUrl = getMediaURL(publication.image);

//     const handleClick = () => {
//         // Use documentId instead of id for Strapi v5
//         navigate(`/${URL_ENDPOINTS.PUBLICATIONS}/${publication.slug}`);
//     };

//     return (
//         <div
//             className="border border-gray-300 rounded-lg overflow-hidden mb-5 transition-all duration-200 cursor-pointer bg-white shadow-md hover:shadow-lg hover:-translate-y-1 md:mb-6 lg:mb-8"
//             onClick={handleClick}
//         >
//             {imageUrl && (
//                 <img
//                     src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                     alt={publication.title}
//                     className="w-full h-48 object-cover sm:h-56 md:h-64 lg:h-72"
//                 />
//             )}
//             <div className="p-4 sm:p-5 md:p-6">
//                 <h3 className="text-xl font-semibold mb-2 text-gray-800 sm:text-2xl md:mb-3">
//                     {publication.title}
//                 </h3>
//                 <div className="text-gray-600 leading-relaxed mb-2 text-sm sm:text-base md:mb-3">
//                     <ReactMarkdown>
//                         {publication.description?.length > 150
//                             ? publication.description.substring(0, 150) + '...'
//                             : publication.description || ''}
//                     </ReactMarkdown>
//                 </div>
//                 {publication.publishedAt && (
//                     <p className="text-sm text-gray-400 sm:text-base">
//                         {formatDate(publication.publishedAt)}
//                     </p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default PublicationCard;

import { useNavigate } from 'react-router-dom';
import { getMediaURL, formatDate } from '../../utils/helpers';
import { URL_ENDPOINTS } from '../../config/constants';
import { toTurkishDate } from '../../utils/dateConvertToTr'

const PublicationCard = ({ publication }) => {
    const navigate = useNavigate();
    const imageUrl = getMediaURL(publication.image) || '/placeholder_hor.jpg';

    const handleClick = () => {
        navigate(`/${URL_ENDPOINTS.PUBLICATIONS}/${publication.slug}`);
    };

    const getPlainTextDescription = (markdown, maxLength = 150) => {
        if (!markdown) return '';

        let plainText = markdown
            .replace(/[#*`~_\[\]()]/g, '')
            .replace(/!\[.*?\]\(.*?\)/g, '')
            .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
            .replace(/^[-*+]\s+/gm, '')
            .replace(/^\d+\.\s+/gm, '')
            .replace(/\n+/g, ' ')
            .trim();

        return plainText.length > maxLength
            ? plainText.substring(0, maxLength).trim() + '...'
            : plainText;
    };

    return (
        <div
            className="group border border-gray-200 rounded-xl overflow-hidden mb-4 transition-all duration-300 cursor-pointer bg-white hover:shadow-xl hover:-translate-y-0.5 md:mb-5"
            onClick={handleClick}
        >
            {imageUrl && (
                <div className="relative overflow-hidden aspect-[16/9]">
                    <img
                        src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
                        alt={publication.title}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                </div>
            )}

            <div className="p-5 flex flex-col h-[180px]">

                {/* Title (never shrinks) */}
                <h3 className="text-lg font-bold mb-2 text-gray-900 line-clamp-2 shrink-0 group-hover:text-blue-600 transition-colors">
                    {publication.title}
                </h3>

                {/* Description wrapper (can shrink, prevents overflow into date) */}
                <div className="flex-grow min-h-0 pb-2 overflow-hidden">
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 md:line-clamp-3 overflow-hidden">
                        {getPlainTextDescription(publication.description, 150)}
                    </p>
                </div>

                {/* Date (always visible, fixed space) */}
                {publication.publishedAt && (
                    <p className="text-xs text-gray-400 pt-3 mt-auto border-t border-gray-100 h-[28px] shrink-0 bg-white relative z-10">
                        {toTurkishDate(publication.publishedAt)}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PublicationCard;
